<template>
  <div>
    <van-nav-bar
      title="确认订单"
      left-arrow
      :fixed="true"
      class="my-nav"
      @click-left="$router.back(-1)"
      :z-index="100"
    />
    <div style="margin-top: 50px;margin-bottom: 60px; color:#666; font-size: 14px;">
      <!-- 联系人卡片 -->
      <van-cell-group v-if="!shippingAddress.name">
        <van-cell title="请添加收货地址" is-link value="点击添加" @click="$router.push('/address-edit')" />
      </van-cell-group>
      <div
        v-else
        @click="$router.push('/address')"
        class="van-cell van-cell--center van-contact-card van-contact-card--add"
      >
        <div class="van-cell__value van-cell__value--alone" style="line-height: 30px;">
          <div>
            <span>
              <van-icon name="contact" />
              收货人: {{shippingAddress.name}}
            </span>
            <span style="margin-left: 20px;">{{shippingAddress.phone}}</span>
          </div>
          <div>
            <span >
              <van-icon name="location-o" />
              收货地址: {{shippingAddress.region + "  " + shippingAddress.address}}
            </span>
          </div>
        </div>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </div>
      <!--订单列表-->
      <div v-for="buy in buyList" :key="buy.id" style="padding-top: 5px; background: #fafafa;">
        <van-panel>
          <van-nav-bar slot="header" >
            <div slot="left">
              <van-icon name="shop-o"  style="color:#000"/>
              {{buy.name}}
            </div>
          </van-nav-bar>
          <van-card
            v-for="item in buy.commodity"
            :title="item.title"
            :desc="item.standard.replace('null/','').replace('undefined','').replace(/null/g,'').replace(/\//g,'')+'/'+item.color"
            :price="formatPrice(item.price)"
            :num="item.count"
            :thumb="item.thumb"
            :key="item.id"
          />
          <div slot="footer" class="van-clearfix" style="color: #666">
            <div style="float: right;font-size: small">
              订单金额: ￥{{formatPrice(totalPrice(buy.commodity))}} 合计 :
              <span style="color:red;">￥ {{formatPrice(totalPrice(buy.commodity) + buy.freight)}}</span>
              (运费￥{{formatPrice(buy.freight)}})
            </div>
          </div>
        </van-panel>
      </div>

      <!-- <div style="margin: 10px;font-size: 13px">发票结算 <span
      style="margin-left:15px;color: red;font-size: xx-small">提示:请在个人中心提交开票申请</span></div>-->

      <van-cell-group>
        <van-cell
          :title="'配送方式 ('+deliverWay+')'"
          icon="location-o"
          @click="showDeliverWay = true"
          is-link
        />
      </van-cell-group>

      <van-cell-group>
        <div class="goods" style="border-top: 2px solid #fafafa;background: #fff">
          <p>
            商品:
            <span>{{allTotalNumber}}件</span>
          </p>
          <p>
            商品总额:
            <span>￥{{formatPrice(allTotalPrice)}}</span>
          </p>
          <p>
            运费:
            <span>￥ {{formatPrice(allTotalFreight)}}</span>
          </p>

<!--            <p>提示: <span  style="color:red;"> 三台以下运费到付</span></p>-->
        </div>
      </van-cell-group>
    </div>

    <van-submit-bar :price="allTotalPrice*100" button-text="提交订单" @submit="onSubmit" />

    <!--选择配送方式-->
    <van-popup position="bottom" v-model="showDeliverWay">
      <div style="margin: 15px;">配送方式</div>
      <van-radio-group v-model="deliverWayType">
        <van-cell-group>
         <!-- <van-cell title="自取" clickable @click="deliverWayType = 'SELF'">
            <van-radio slot="right-icon" name="SELF" />
          </van-cell>-->
          <van-cell title="快递" clickable @click="deliverWayType = 'EXPRESS'">
            <van-radio slot="right-icon" name="EXPRESS" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div style="margin: 15px;">
        <van-button type="danger" block @click="showDeliverWay = false">确定</van-button>
      </div>
    </van-popup>

    <!--选择支付方式-->
    <!--<van-popup position="bottom" v-model="showPay">
      <div style="margin: 15px;">支付方式</div>
      <van-radio-group v-model="bus.state.payType">
        <van-cell-group>
          <van-cell title="个人网银" clickable @click="bus.state.payType = 'online'">
            <van-radio slot="right-icon" name="online" />
          </van-cell>
          <van-cell title="线下支付" clickable @click="bus.state.payType = 'offline'">
            <van-radio slot="right-icon" name="offline" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div style="margin: 15px;">
        <van-button  block type="danger" bottom-action @click="onSubmit">确定</van-button>
      </div>
    </van-popup>-->
  </div>
</template>

<script>
import { Toast } from "vant";
import bus from "../../bus";
import getFreightPrice from "../../api/order/submit/freight";
import getShippingAddress from "../../api/order/submit/shipping-address";
import save from "../../api/order/submit";
import { deleteCartAll, initCartGoodsNum } from "../../api/carts";
import {getIfShowAddBtn} from "../../api/address";

export default {
  data() {
    return {
      shippingAddress: {
        /*"id": 214,
          "name": "张三",
          "enabled": true,
          "phone": "15166635231",
          "region": "山东省 济南市 槐荫区",
          "address": "1234是对方的手放到是斯蒂芬5"*/
      },
      showDeliverWay: false,
      showPay: false,
      deliverWayType: "EXPRESS",
      buyList: bus.state.buyList,
      bus
    };
  },
  methods: {
    formatPrice(price) {
      return Number.parseInt(price).toFixed(2);
    },
    totalPrice(commodity) {
      return commodity.reduce((x, y) => x + y.price * y.count, 0);
    },
    totalNumber(commodity) {
      return commodity.reduce((x, y) => x + y.count, 0);
    },
    onSubmit() {
      if (!this.shippingAddress.name) {
        Toast("请添加收货地址");
        return;
      }
      let shippingAddress = JSON.parse(JSON.stringify(this.shippingAddress));
      shippingAddress.region = shippingAddress.region.replace(/ /g, "-");
      let orderSubmit = {
        address: shippingAddress,
        deliverWay: this.deliverWayType,
        origin: bus.state.cartSubmitFlag ? "SHOPPING_CART" : "BUY_NOW"
      };
      orderSubmit.list = this.buyList.map(buy => ({
        shopId: buy.id,
        name: buy.name,
        commodity: buy.commodity.map(item => ({
          skuId: item.skuId,
          count: item.count
        }))
      }));
      save(
        orderSubmit,
        orderCodes => {
          bus.state.orderCodes = orderCodes;
          bus.state.buyList = [];
          bus.state.enableAddress=undefined;
          bus.state.tempAddress=undefined;
          initCartGoodsNum();
         /* this.showPay = false;
          if (bus.state.payType === "online") {
            //TODO 个人网银
            this.$router.push("bank-card-pay");
          } else if (bus.state.payType === "offline") {*/
            this.$router.push("pay");
          // }
        },
        e => Toast(e)
      );
    },
    loadFreightPrice(buy) {
      let params = {
        shopId: buy.id,
        totalNum: this.totalNumber(buy.commodity),
        totalPrice: this.totalPrice(buy.commodity)
      };
      getFreightPrice(params, data => {
        this.$set(buy, "freight", data);
      });
    },
  },
  computed: {
    allTotalPrice() {
      let totalFreight = this.buyList.reduce((x, y) => x.freight + y.freight, ({freight:0}))
      return this.buyList.reduce((x, y) => x + this.totalPrice(y.commodity), 0)+totalFreight;
    },
    allTotalNumber() {
      return this.buyList.reduce((x, y) => {
        return x + y.commodity.reduce((x1, y1) => x1 + y1.count, 0);
      }, 0);
    },
    allTotalFreight() {
      return this.buyList.reduce((x, y) => x + y.freight, 0);
    },
    deliverWay() {
      if (this.deliverWayType === "SELF") {
        return "自提";
      } else if (this.deliverWayType === "EXPRESS") {
        return "快递";
      } else if (this.deliverWayType === "SF") {
        return "顺丰";
      }
    }
  },
  mounted() {
    if (bus.state.buyList < 1) {
      this.$router.back(-1);
    }
    if (!bus.state.payType) {
      bus.state.payType = "offline";
    }
    this.buyList.forEach(buy => this.loadFreightPrice(buy));
    // 判断是否是直发商品 直发商品地址获取缓存中选中的
    getShippingAddress(data => {
      this.shippingAddress = data;
    });
    if(bus.state.buyList.length){
      let shopId;
      let skuCodes = [];
      bus.state.buyList.forEach(buy => {
        shopId=buy.id,
        skuCodes.push(buy.commodity.map(s => {
          return s.skuCode
        }))
      });
      getIfShowAddBtn({shopId, skuCodes: skuCodes.join(",")}, data => {
        if(data){
          this.shippingAddress = bus.state.enableAddress
        }
      }, e => {
        Toast.fail(e);
      })
    }

  }
};
</script>

<style lang="less" scoped>
.goods {
  font-size: 13px;
  color: #666;
  padding: 15px 20px;
}

.goods span {
  float: right;
}
</style>
